"use strict";
// _contact-form.js
// フォーム3ステップ制御
//   - 入力ページ  (#entry)   : sessionStorageに保存 → 確認ページへ遷移
//   - 確認ページ  (#confirm) : sessionStorageから表示 → mail.php（PHP工房）へ POST
//   - 完了ページ  (#complete): sessionStorageをクリア

// sessionStorageキー
var STORAGE_KEY = "contactFormData";

var FORM_ENTRY_PAGES = {
  general: "contact.html",
  sougi: "contact-sougi.html",
  kasou: "contact-kasou.html",
};

function getEntryPage(formType) {
  return FORM_ENTRY_PAGES[formType] || FORM_ENTRY_PAGES.general;
}

function applyDedicatedContactLayout(formType) {
  if (formType !== "kasou" && formType !== "sougi") return;

  var container = document.getElementById("contactMainContainer");
  var fvKasou = document.getElementById("contactFvKasou");
  var fvSougi = document.getElementById("contactFvSougi");
  var telWrap = document.getElementById("contactTelWrap");

  if (!container || !telWrap) return;

  container.classList.add("-container--contact");

  var section = document.getElementById("contactSection");
  var inner = document.getElementById("contactInner");
  var headGeneral = document.getElementById("contactHeadGeneral");

  if (section && inner) {
    section.classList.add("-contact--common");
    inner.classList.remove("-inner--contact");
    inner.classList.add("-inner--contactFv");
  }

  var guide = document.getElementById("contactGuide");

  if (headGeneral) headGeneral.hidden = true;
  if (guide) guide.hidden = false;
  telWrap.hidden = false;

  if (formType === "kasou" && fvKasou) fvKasou.hidden = false;
  if (formType === "sougi" && fvSougi) fvSougi.hidden = false;
}

function applyDedicatedThanksLayout(formType) {
  if (formType !== "kasou" && formType !== "sougi") return;

  var isPc = window.matchMedia("(min-width: 768px)").matches;
  if (!isPc) return;

  var container = document.getElementById("contactMainContainer");
  var fvKasou = document.getElementById("contactFvKasou");
  var fvSougi = document.getElementById("contactFvSougi");
  var thanksSection = document.getElementById("contactThanksSection");
  var thanksInner = document.getElementById("contactThanksInner");

  if (!container) return;

  container.classList.add("-container--contact");

  if (thanksSection && thanksInner) {
    thanksSection.classList.remove("l-thanks");
    thanksSection.classList.add("l-contact", "-contact--common");
    thanksInner.classList.remove("p-thanks", "-inner--thanks");
    thanksInner.classList.add("p-contact", "-inner--contactFv");
  }

  if (formType === "kasou" && fvKasou) fvKasou.hidden = false;
  if (formType === "sougi" && fvSougi) fvSougi.hidden = false;
}

// ===================================
// 入力ページ (#entry)
// ===================================
if (document.querySelector("#entry")) {
  var entryForm = document.querySelector("#contact-form");
  var entryButton = entryForm ? entryForm.querySelector("#button") : null;

  if (entryForm && entryButton) {
    entryButton.addEventListener("click", function (event) {
      if (entryButton.disabled) return;

      var formType = entryForm.getAttribute("data-form-type") || "general";
      var name = document.querySelector("#inName")
        ? document.querySelector("#inName").value.trim()
        : "";
      var email = document.querySelector("#inEmail")
        ? document.querySelector("#inEmail").value.trim()
        : "";
      var hall = document.querySelector("#inHall")
        ? document.querySelector("#inHall").value
        : "";
      var inquiry = document.querySelector("#inSelect")
        ? document.querySelector("#inSelect").value
        : "";
      var detail = document.querySelector("#inDetail")
        ? document.querySelector("#inDetail").value.trim()
        : "";

      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          formType: formType,
          name: name,
          email: email,
          hall: hall,
          inquiry: inquiry,
          detail: detail,
        })
      );
      event.preventDefault();
      window.location.href = "contact-confirm.html";
    });
  }
}

// ===================================
// 確認ページ (#confirm)
// ===================================
if (document.querySelector("#confirm")) {
  var storedData = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "null");

  if (!storedData) {
    window.location.href = "contact.html";
  } else {
    var entryPage = getEntryPage(storedData.formType);

    if (storedData.formType === "kasou" || storedData.formType === "sougi") {
      applyDedicatedContactLayout(storedData.formType);
    }

    function setConfirmValue(selector, value) {
      var el = document.querySelector(selector);
      if (el) el.textContent = value || "";
    }
    setConfirmValue("#confirmHall", storedData.hall);
    setConfirmValue("#confirmName", storedData.name);
    setConfirmValue("#confirmEmail", storedData.email);
    setConfirmValue("#confirmInquiry", storedData.inquiry);
    setConfirmValue("#confirmDetail", storedData.detail);

    var postFormType = document.getElementById("postFormType");
    var postHall = document.getElementById("postHall");
    var postName = document.getElementById("postName");
    var postEmail = document.getElementById("postEmail");
    var postInquiry = document.getElementById("postInquiry");
    var postDetail = document.getElementById("postDetail");
    if (postFormType) postFormType.value = storedData.formType || "general";
    if (postHall) postHall.value = storedData.hall || "";
    if (postName) postName.value = storedData.name || "";
    if (postEmail) postEmail.value = storedData.email || "";
    if (postInquiry) postInquiry.value = storedData.inquiry || "";
    if (postDetail) postDetail.value = storedData.detail || "";

    var backLink = document.getElementById("confirmBackLink");
    if (backLink) backLink.href = entryPage;

    var mailForm = document.getElementById("phpMailForm");
    var sendButton = document.querySelector("#confirmSendBtn");
    if (mailForm && sendButton) {
      mailForm.addEventListener("submit", function () {
        sendButton.disabled = true;
        sendButton.textContent = "送信中…";
      });
    }
  }
}

// ===================================
// 完了ページ (#complete)
// ===================================
if (document.querySelector("#complete")) {
  var completeData = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "null");

  if (completeData) {
    if (completeData.formType === "kasou" || completeData.formType === "sougi") {
      applyDedicatedThanksLayout(completeData.formType);
    }

    var thanksBackLink = document.getElementById("thanksBackLink");
    if (thanksBackLink) {
      thanksBackLink.href = getEntryPage(completeData.formType);
    }
  }

  sessionStorage.removeItem(STORAGE_KEY);
}
